export const CONFIG_BY_CHANNEL = {
  instagram__instagram: {
    emojis: ['❤️'],
    containerClass: 'feed-reactions-emoji__favs--minor'
  },
  whatsapp__whatsapp: {
    emojis: ['👍', '❤️', '😂', '😮', '😢', '🙏', 'EmojiSelector'],
  }
}

export const HEART_EMOJI = {
  emoji: '❤️',
  list: ['❤️', 'love', 'heart']
}
